<script>
import { optionsComputed, navComputed, authComputed } from '@state/helpers'
import { constants } from '@src/constants/safehaven'
import AddHrDialogReport from '@/src/components/dialogs/safehaven/add-hr-dialog-report.vue'
import CollapsibleList from '@/src/components/tables/safehaven-collapsible-list.vue'
import { healthRecordService } from '@/src/services/HealthRecordService'
import store from '@/src/state/store'
import { healthRecordsList } from '@views/safehaven/health-record/health-record-data'

export default {
  name: 'HrList',
  page: {
    title: 'Health Records',
    meta: [{ name: 'description', content: 'The Health Records page.' }],
  },
  components: {
    CollapsibleList,
    AddHrDialogReport,
  },
  props: {
    sympdfrecords: {
      type: Array,
      required: false,
      default: () => [],
    },
    group: {
      type: Number,
      default: 0,
    },
    hRecord: {
      type: Array,
      default: null,
    },
    shared: {
      type: Boolean,
      default: false,
    },
    recipientid: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      allData: healthRecordsList,
      tableView: false,
      addDialog: false,
      dialog: null,
      showMenu: false,
      dialogEnabled: false,
      disableButton: false,
      formChanged: false,
      formSaved: false,
      confirmDialog: false,
      toDelete: null,
      informationDialog: false,
      sharingDialog: false,
      menuItems: constants.healthRecord,
      hrGroups: {
        1: 'medical history',
        2: 'medications',
        3: 'diagnostics',
        4: 'allergies',
        5: 'visits',
      },
      selectedMenuItem: null,
      resourceMenuItem: null,
      resourceItem: null,
      reloadMap: {},
      loading: true,
      hasDataArr: [],
      edit: false,
      addNewflag: false,
      datatableIndexes: this.createDatatableIndexes(),
      x: 0,
      y: 0,
    }
  },
  computed: {
    ...authComputed,
    ...navComputed,
    ...optionsComputed,
    mobile() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
    },
    openRightSideDrawer() {
      return this.calendarDrawer || this.settingsDrawer
    },

    computedMenuItems() {
      const sortedMenuItem = []
      this.allData.forEach((element) => {
        sortedMenuItem.push(
          Object.values(this.menuItems).find(
            (x) => x.plain_resource === element
          )
        )
      })
      return sortedMenuItem
    },
    computedMessage() {
      return `Are you sure you want to delete
          ${this.toDelete.item.record_type_label}
          ( ${this.toDelete.item.label} ) ?`
    },
    hasData() {
      return this.hasDataArr.length && this.hasDataArr.some((el) => el !== 0)
    },
  },
  watch: {
    computedMenuItems: {
      deep: true,
      immediate: false,
    },
  },
  methods: {
    closeDialog() {
      this.dialog = null
      this.dialogEnabled = false
    },

    selectSection(item) {
      this.showMenu = false
      this.selectedMenuItem = item
      this.dialogEnabled = true
    },

    addItem({ resource }) {
      const menuItem = this.getMenuItemFromResource(resource)

      // Give as a prop to add-hr-dialog the menuItem
      this.resourceMenuItem = menuItem
      this.edit = true
      this.addDialog = true
      this.addNewflag = true
      store.dispatch('calender/setAddNewRecords', 'true')
    },
    editItem({ item, resource, attachments }) {
      const menuItem = this.getMenuItemFromResource(resource)

      // Give as a prop to add-hr-dialog the menuItem
      this.resourceMenuItem = menuItem
      // Give as a prop item
      this.resourceItem = item
      // Open dialog
      this.edit = true
      this.addDialog = true
      this.addNewflag = false
      store.dispatch('calender/setAddNewRecords', 'false')

      if (attachments) {
        setTimeout(() => {
          store.dispatch('animations/setHighlightAttachments', true)
          const target = document.getElementById('#attachments')
          if (target) {
            this.$vuetify.goTo(target, {
              container: '#componentArea',
              duration: 800,
              easing: 'easeInOutCubic',
            })
          }
        }, 1000)
      }
    },
    getMenuItemFromResource(resource) {
      for (const key in this.menuItems) {
        if (this.menuItems[key].resource === resource) {
          return this.menuItems[key]
        }
      }
      return null
    },
    createDatatableIndexes() {
      const result = { ...constants.healthRecordModels }
      for (const property in result) {
        result[property] = 0
      }
      return result
    },
    changeIndex(resource) {
      if (
        Object.prototype.hasOwnProperty.call(this.datatableIndexes, resource)
      ) {
        this.datatableIndexes[resource]++
      }
    },
    saved(item) {
      this.reloadMap[item.editor] = !this.reloadMap[item.editor]
    },
    cancel() {
      this.confirmDialog = false
    },
    prepareDeletion(item) {
      this.toDelete = item
      this.confirmDialog = true
    },
    async confirmDelete() {
      try {
        const deleteResponse = await healthRecordService.delete(
          this.toDelete.item.hr_id
        )

        if (deleteResponse.status === 200) {
          store.dispatch('healthrecords/setActionStatus', {
            action: 'remove',
            status: true,
            item: this.toDelete.item,
          })
          this.confirmDialog = false
          const menuItem = this.getMenuItemFromResource(this.toDelete.resource)
          this.reloadMap[menuItem.editor] = !this.reloadMap[menuItem.editor]
        }
      } catch (error) {
        console.warn(error)
      }
    },

    updateData() {},
    setHasData(data) {
      this.hasDataArr.push(data)
      this.loading = false
    },
    deleteFromHr(resource) {
      const menuItem = this.getMenuItemFromResource(resource)
      this.reloadMap[menuItem.editor] = !this.reloadMap[menuItem.editor]
    },
  },
}
</script>

<template>
  <v-container fluid class="pa-0">
    <div id="recordList">
      <AddHrDialogReport
        :group="group"
        :dialog.sync="addDialog"
        :edit.sync="edit"
        :menu.sync="resourceMenuItem"
        :item.sync="resourceItem"
        @form-saved="saved"
        @delete-from-hr="deleteFromHr"
        @update-data="updateData"
      ></AddHrDialogReport>
      <BaseConfirmDialog
        v-if="confirmDialog"
        :dialog="confirmDialog"
        :message="computedMessage"
        title="Delete Item"
        @cancel="cancel"
        @confirm="confirmDelete"
      />
      <v-container v-if="hRecord" fluid>
        <template>
          <v-row
            v-for="model in computedMenuItems"
            :key="
              model.plain_resource +
                '-' +
                datatableIndexes[model.plain_resource]
            "
          >
            <v-fade-transition mode="out-in">
              <CollapsibleList
                :pdfrecords="sympdfrecords"
                :reload="reloadMap[model.editor]"
                :icon="model.icon"
                :color="model.color"
                :opaque="model.opaque"
                :headers="model.headers"
                :sortables="model.sortables"
                :title="$t(model.title)"
                :subtitle="
                  model.list_title ? $t(model.list_title) : $t(model.title)
                "
                :image="model.imageURL"
                :resource="model.resource"
                :shared="shared"
                :recipientid="recipientid"
                @has-data="setHasData"
                @show-item="editItem"
                @add-item="addItem"
                @delete-item="prepareDeletion"
              ></CollapsibleList>
            </v-fade-transition>
          </v-row>
        </template>
      </v-container>
    </div>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.fabButton {
  transform: translateX(-300px);
}
.dialogContainer {
  border-radius: 24px !important;
}

.menuTab :hover {
  color: white;
  background: $color-theme-light-primary;
  border-radius: 24px;
}

.cardTitleHeader {
  font-family: $system-default-font-family;
}

.noDataRow {
  justify-content: center;
}

.noDataButtonRow {
  justify-content: center;
  width: 100%;
}

.noDataButton {
  font-size: 13px !important;
  font-weight: 600;
  letter-spacing: 0.25px !important;
  border-radius: 8px;
}

.noDataTitle {
  justify-content: center;
  width: 100%;
  margin-top: 16px;
  margin-bottom: 7px;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 1px;
}

.noDataSubtitle {
  justify-content: center;
  width: 100%;
  margin-bottom: 25px;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0.75px;
}

.loadingRow {
  width: 100%;
  height: 40vh;
}
</style>
